import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { navItems } from '../mockData';
import { SITE_LOGO_PATH } from '../config/brand';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-white'}`}>
      {/* Top Bar */}
      <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex min-w-0 items-center">
              <div className="flex min-w-0 items-center">
                <img
                  src={SITE_LOGO_PATH}
                  alt="Swaarnim Book of Records logo"
                  className="h-14 w-48 object-contain object-left sm:h-16 sm:w-56 lg:w-64"
                />
              </div>
            </Link>

            {/* Contact Info - Desktop */}
            <div className="hidden md:flex items-center gap-8">
              <Button asChild className="bg-red-700 hover:bg-red-800 text-white font-semibold px-6 py-2 rounded transition-all duration-300 hover:scale-105">
                <Link to="/how-to-apply">Set A Record</Link>
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden text-gray-700"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
      <nav className="bg-red-700 hidden md:block">
        <div className="container mx-auto px-4">
          <ul className="flex items-center justify-center gap-1">
            {navItems.map((item) => (
              <li key={item.id}>
                <Link
                  to={item.path}
                  className={`block px-4 py-3 text-white text-sm font-medium hover:bg-red-800 transition-colors duration-300 ${
                    location.pathname === item.path ? 'bg-red-800' : ''
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="container mx-auto px-4 py-4">
            <ul className="space-y-2">
              {navItems.map((item) => (
                <li key={item.id}>
                  <Link
                    to={item.path}
                    className={`block px-4 py-2 text-gray-700 hover:bg-gray-100 rounded transition-colors ${
                      location.pathname === item.path ? 'bg-gray-100' : ''
                    }`}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <Button asChild className="w-full mt-4 bg-red-700 hover:bg-red-800 text-white font-semibold">
              <Link to="/how-to-apply" onClick={() => setIsMobileMenuOpen(false)}>
                Set A Record
              </Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
